import {viewModel as MutableSystemPermission} from './mutable';
import {global} from "../../appContext";
import {ISystem} from "../../index";
import PromiseRequest from "../../req/PromiseRequest";
import {createErrorMessage} from "../../util/misc";
import {CREATING_MESSAGE} from "../../constants/Language";
import {setRouteHash} from "../../constants/RouteDefinitions";
import {trackSurvicateEvent} from "../../util/survicate";

export {template} from './mutable';

export class viewModel extends MutableSystemPermission {

    protected reqSubmit = new PromiseRequest('createsystem');

    protected override d: ISystem = {
        availableto_id: 0,
        companyid: global.login.selectedOrganizationId() ?? '',
        description: '',
        id: 0,
        isreadonly: false,
        managedby_id: 0,
        multiplerolesamecompany: true,
        multiplerolesamedepartment: true,
        name: '',
        prioritybasedroles: false,
        purgemanualdepartmentpermissions: false,
        roles: [],
        systemowner: '',
    };

    protected override init() {
        this.messageData(null);

        this.md.availableto(null)
        this.md.description('')
        this.md.managedby(null)
        this.md.multiplerolesamecompany(true)
        this.md.multiplerolesamedepartment(true)
        this.md.name('')
        this.md.prioritybasedroles(false)
        this.md.purgemanualdepartmentpermissions(false)
        this.md.roles([])
        this.md.systemowner('')

        this.isReady(true);
    }

    protected onSubmit() {
        trackSurvicateEvent('ces.collection.create');
        
        this.isReady(false);
        this.messageData({message: CREATING_MESSAGE});
        const submitData = this.getSubmitData();
        const json = JSON.stringify(submitData);

        Promise.resolve()
            .then(() => {
                // create system access object
                return this.reqSubmit.request({jsystem: json})
                    .then((data: ISystem[]) => {
                        const system = data[0];
                        if (system) {
                            this.d = system;
                        }
                    });
            })
            .then(() => {
                // create roles
                return Promise.all(this.getCreatedRoles().map(r => {
                    return new PromiseRequest('createrole').request({jrole: JSON.stringify(r)});
                }));
            })
            .then(() => {
                // cleanup
                global.cacheManager.removeCache('getruleset');
                global.cacheManager.removeCache('searchruleset');
                global.cacheManager.removeCache('searchsystem');
                global.snackbarData({message: `subject is created|s:((collection))`});
                setRouteHash('systemaccessdetails', {id: this.d.id});
            })
            .catch(reason => {
                this.reqSubmit.abort();
                this.messageData(createErrorMessage(String(reason)));
                this.isReady(true);
            });
    }

    protected override getSubmitData(): ISystem {
        const d = super.getSubmitData();
        d.id = 0;
        return d;
    }

}
